
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/air-freight",
      function () {
        return require("private-next-pages/account/air-freight/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/air-freight"])
      });
    }
  